var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "474c8135-07fe-4350-b8ec-7ed2ad1f2267"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "dd63de56-6cc6-4314-a046-f5449722b7d0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.69 0 0 14.69 524.37 540)",
    id: "2d6f8dce-d4cd-46e3-8b8f-9495571c4d4a"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(112,173,71)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.04 0 0 8.56 540 540)",
    id: "65c6fa5d-208a-4e10-8c6c-a09dbb5d2402"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -50)",
    d: "M 14.148 44.105 L 18.091 40.162 C 20.01 38.242 23.176000000000002 38.242 25.096 40.162 L 42.164 57.230999999999995 L 74.904 24.440999999999995 C 76.823 22.521999999999995 79.98899999999999 22.521999999999995 81.90899999999999 24.440999999999995 L 85.851 28.383999999999997 C 87.771 30.302999999999997 87.771 33.415 85.851 35.334999999999994 L 45.641 75.54499999999999 L 45.537 75.64899999999999 L 45.433 75.75299999999999 L 45.329 75.80499999999999 L 45.277 75.90899999999999 L 45.173 75.961 L 45.069 76.065 L 44.965 76.117 L 44.861000000000004 76.16900000000001 L 44.757000000000005 76.27400000000002 L 44.653000000000006 76.32400000000001 L 44.54900000000001 76.37800000000001 L 44.44500000000001 76.43000000000002 L 44.34100000000001 76.48200000000003 L 44.23700000000001 76.53400000000003 L 44.08000000000001 76.58600000000004 L 43.97600000000001 76.63800000000005 L 43.872000000000014 76.69000000000005 L 43.768000000000015 76.74200000000006 L 43.664000000000016 76.74200000000006 L 43.56000000000002 76.79400000000007 L 43.405000000000015 76.84700000000007 L 43.301000000000016 76.84700000000007 L 43.19700000000002 76.89900000000007 L 42.93800000000002 76.89900000000007 L 42.83400000000002 76.95100000000008 L 42.62600000000002 76.95100000000008 L 42.47100000000002 77.00300000000009 L 41.795000000000016 77.00300000000009 L 41.640000000000015 76.95100000000008 L 41.432000000000016 76.95100000000008 L 41.32800000000002 76.89900000000007 L 41.06900000000002 76.89900000000007 L 40.96500000000002 76.84700000000007 L 40.86100000000002 76.84700000000007 L 40.70600000000002 76.79400000000007 L 40.60200000000002 76.74200000000006 L 40.49800000000002 76.74200000000006 L 40.39400000000002 76.69000000000005 L 40.29000000000002 76.63800000000005 L 40.185000000000024 76.58600000000004 L 40.081000000000024 76.53400000000003 L 40.029000000000025 76.53400000000003 C 39.563000000000024 76.32500000000003 39.096000000000025 75.96200000000003 38.630000000000024 75.54800000000003 L 14.140000000000025 51.059000000000026 C 12.229 49.137 12.229 46.025 14.148 44.105 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.4e00b1ee2abc35f00be2d8947034e324.svg";
export { ForwardRef as ReactComponent };